const styles = (theme) => ({
  paper: {
    borderRadius: '2px',
    minWidth: '130px',
  },
  list: {
    padding: 0,
  },
  white: {
    color: theme.color.white,
  },
});

export default styles;
